module.exports = __webpack_public_path__ + "static/media/image-placeholder.95c677ea.svg";